import React, { useState } from "react";
import { ChevronLeft } from "react-bootstrap-icons";
import Style from "../Accardion.module.scss";
import { BasketFill } from "react-bootstrap-icons";
import AccardionItem from "../AccardionItem/AccardionItem";
import { Badge } from "antd";
const Accardion5 = ({dataCount}) => {
    const totalCount=parseInt(dataCount?.supplier_support)+parseInt(dataCount?.user_support)
    const [openOnClick , setOpenOnClick]=useState(false)
    const support = [
        {
            id: "1",
            title: "تامین کننده",
            link: "/suppliersupport",
            active: window.location.pathname === "/suppliersupport",
            count:parseInt(dataCount?.supplier_support)
        },
        {
            id: "2", 
            title: "کاربر",
            link: "/usersupport",
            active: window.location.pathname === "/usersupport",
            count:parseInt(dataCount?.user_support)
        },
        {
            id: "3", 
            title: "پیک",
            link: "/deliverysupport",
            active: window.location.pathname === "/deliverysupport",
            count:parseInt(dataCount?.delivery_support)
        }
    ];
    let value = false;
    support.forEach((element) => {
        if (element.active) {
            value = true;
        }
    });
    const openHandler=()=>{
        if(openOnClick){
            setOpenOnClick(false)
        }
        else{
            setOpenOnClick(true)
        }
    }
    return (
        <div className={Style.accardionChild}>
            <div className={value || openOnClick?Style.background :Style.accardionTitle} 
            onClick={openHandler}>
                <ChevronLeft />
                <div className={Style.right}>
                    <p className={Style.accardionText}><Badge count={totalCount}/>  پیام های پشتیبانی</p>
                    <BasketFill />
                </div>
            </div>
            {support === undefined ? null : (
                <div className={value || openOnClick?Style.accardionContent:Style.hidden}>
                    <AccardionItem accardonItem={support && support} />
                </div>
            )}
        </div>
    );
};

export default Accardion5;
